<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 头部顶部 -->
    <!-- <div class="header-top container-fuild hidden-xs">
      <div class="container">
        <div class="server pull-left">
          <span class="glyphicon glyphicon-earphone"></span>888-888-888
          <span class="glyphicon glyphicon-envelope"></span>xxx@163.com
          <span class="glyphicon glyphicon-time"></span>7x24小时为您服务
        </div>
        <div class="shejiao pull-right">
          <span class="glyphicon glyphicon-hand-right"></span>赶快联系我们吧！
          <span class="glyphicon glyphicon-hand-left"></span>
        </div>
      </div>
    </div> -->
    <!-- 电脑导航 -->
    <div class="header-nav container hidden-xs">
      <!-- 导航logo -->
      <div class="header-nav-logo">
        <img src="@/assets/img/logo.png" />
        <div class="title">
         {{ $t('home.title')}}
        </div>
      </div>
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <li v-for="(item, index) in navList" :key="index" :class="index == navIndex ? 'active' : ''">
          <a @click="navClick(index, item)">
            {{ item.meta.title }}
            <span v-if="item.list && item.list.length > 0" class="glyphicon glyphicon-menu-down"></span>
            <i class="underline"></i>
          </a>
          <dl v-if="item.list && item.list.length > 0">
            <dt v-for="(i, n) in item.list" @click="getComindex(n, item, index)" :key="n">
              <el-tooltip :content="i.meta.title" placement="left">
                <a>{{ i.meta.title }}</a>
              </el-tooltip>
            </dt>

          </dl>
        </li>
      </ul>
      <div class="btn-group" role="group">
          <span class="but-span" v-for="(item, index) in butLang" :key="item.value" @click="setInter(item.value)"
                :class="$store.state.lang == item.value ? 'selcolor' : ''">
            {{ index === 1 ? '/' : '' }} {{ item.label }}
          </span>
      </div>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
        <!-- 导航栏 -->
        <div class="header-nav-m-menu text-center">

          <div class="header-nav-m-logo">
            <img src="@/assets/img/logo.png" />
            <div class="title">
              {{ $t('home.title')}}
            </div>
          </div>
<!--          <div style="flex: 1;text-align: left ">{{ menuName }} </div>-->
          <div class="header-nav-m-menu-wrapper" data-toggle="collapse" data-target="#menu" @click="menuClick">
            <span :class="menuClass"></span>
          </div>
          <!-- 导航内容 -->
          <ul id="menu" class="header-nav-m-wrapper collapse">
            <li v-for="(item, index) in navList" :key="index" :class="index == navIndex ? 'active' : ''"
                @click="navClick(index, item)" data-toggle="collapse" data-target="#menu">
              <a>
                {{ item.meta.title }}
                <i class="underline"></i>
              </a>
            </li>

            <li   >
              <a v-for="(item, index1) in butLang" :key="item.value"  @click="setInter(item.value)"
                 :class="$i18n.locale == item.value ? 'selcolor' : ''">
                {{ item.label }}
                {{ index1 === 0 ? '/' : '' }}
              </a>

            </li>

          </ul>
        </div>

    </div>
  </div>
</template>
<script>
export default {
  name: "Header",
  data() {
    return {
      lang: '',
      butLang: [
        {
          label: '中文',
          value: 'zh'
        },
        {
          label: 'English',
          value: 'en'
        },
      ],
      routePath: '',
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      menuName: this.$t('home.homePage'),
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [
      ]
    };
  },
  computed: {
    test() {
      return this.$store.state.routes;
    },
    nav() {
      return this.$store.state.navIndex
    },
    navName(){
      return this.$store.state.menuName
    }
  },
  watch: {
    test: {
      immediate: true,
      handler: function (newval) {
        this.navList = [
          ...newval
        ];
      }
    },
    nav: {
      handler(newval) {
        this.navIndex = newval
      }
    },
    $route(to, from) {
      // console.log(to, 'to');
      if (to.fullPath == '/') {
        this.$store.commit('setNavIndex', 0)
      }
    },
    navName:{
      handler(newval) {
        console.log(123454,newval);
        this.menuName = newval
      }
    }
  },
  methods: {
    navClick(index, item) {
      this.navIndex = index;
      sessionStorage.setItem('navIndex', index);
      // this.menuName = item.meta.title;

      this.$store.commit('setComIndex', 0)
      if (this.$store.state.routePath === item.path) return
      this.$store.commit('setRoutePath', item.path)
      this.$router.push({
        path: item.path
      })
    },
    setInter(val) {
      location.reload();
      this.$store.commit('setInter', val);
    },
    getComindex(index, item, rouIndex) {
      this.navIndex = rouIndex;
      sessionStorage.setItem('navIndex', rouIndex);
      // this.menuName = item.meta.title;

      this.$store.commit('setComIndex', index)
      if (this.$store.state.routePath === item.path) return
      this.$store.commit('setRoutePath', item.path)
      this.$router.push({
        path: item.path
      })

    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    }
  }
};
</script>
<style scoped>
/* 顶部 */
#header {
  background: #FFF;
  transition: all ease 0.6s;
  position: sticky;
  top: 0;
  z-index: 99;
}

a {
  color: #141414;
}

dt:hover {
  background-color: #1ebeb397;
}

dt:hover a {
  color: #196fc5;
}

#header .header-top {
  height: 50px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: #474747;
}

/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}

/* 导航栏 */
#header .header-nav {
  height: 80px;
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}

/* 导航栏logo */
#header .header-nav .header-nav-logo {
  width: 280px;
  height: 100%;
  float: left;
  display: flex;
  align-items: center;
}

/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  /*width: 95px;*/
  height: 50px;
}
/* 导航栏logo图片 */
#header .header-nav .header-nav-logo .title {
  margin-left: 5px;
  font-size: 14px;
  font-weight: bold;
}

/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;

}

#header .header-nav .header-nav-wrapper {
  line-height: 80px;
  margin: 0;
  flex: 1;
  /* max-width: 800px; */
}
.btn-group{
  padding-right: 20px;
}

/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper>li {
  float: left;
  margin: 0 15px;
  position: relative;
  /* max-width: ; */
}


.selcolor {
  color: #196fc5 !important;
}

/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper>li>a {
  color: #000;
  font-size: 14px;
  font-weight: normal;
  padding: 15px 0;
  position: relative;
}

/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper>li>a>i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #196fc5;
}

/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper>li>a>span {
  font-size: 12px;
  transition: transform ease 0.5s;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper>li>a:hover {
  color: #196fc5;
  text-decoration: none;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper>li>a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper>li>a:hover span {
  transform: rotate(180deg);
}

/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper>li.active>a {
  color: #196fc5;
  text-decoration: none;
  border-bottom: 2px solid #196fc5;
}

/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper>li>dl {
  display: none;
  position: absolute;
  width: 168px;
  top: 80%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 3px 1px #ccc;
  background: #fff;
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper>li>dl>dt {
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid #ccc;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: keep-all;
  white-space: nowrap;
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper>li>dl>dt>a:hover {
  text-decoration: none;
}

/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper>li:hover dl {
  display: block;
}

#header .header-nav .header-nav-wrapper>li>dl>dt:hover {
  cursor: pointer;
  background: #042fed0c;
}

.but-span {
  cursor: pointer;
}

@media screen and (max-width: 997px) {
  #header {
    position: sticky;
    top: 0;
    z-index: 99;
  }

  #header .header-nav-m {
    position: relative;
  }

  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    padding-left: 10px;
    width: 250px;
    height: 50px;
    display: flex;
    align-items: center;
  }

  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    /*width: 95px;*/
    height: 30px;
  }
  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo .title {
    margin-left: 5px;
    font-size: 12px;
    font-weight: bold;
  }
  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #474747;
    height: 50px;
    font-size: 14px;
    line-height: 50px;
    /*background: #474747;*/
    position: relative;
    flex: 1;
    display: flex
  }

  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 10px;
    margin-top: -25px;
    width: 20px;
    height: 40px;
    /*color: #fff;*/
    z-index: 999999;
    font-size: 12px;
  }

  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: #474747;
    z-index: 9999999;
  }

  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper>li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }

  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper>li>a {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }

  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper>li>a>span {
    font-size: 10px;
  }

  .button-css {
    -webkit-tap-highlight-color: transparent;
    -webkit-focus-ring-color: none;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue